/* eslint-disable no-useless-constructor */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Input as InputField } from '../../../containers/Form';

function Input(props) {
  const getMyStateFromProps = () => {
    const { filterDefinition, filters } = props;
    const { group } = filterDefinition;

    let myState;
    filters.forEach(e => {
      if (e.group === group) myState = e.state;
    });

    return myState;
  };

  useEffect(() => {
    // if state is not defined in filters from props, lets publish as cleared
    if (getMyStateFromProps() === undefined) {
      const { updateFilterState, filterDefinition } = props;
      const { group } = filterDefinition;
      updateFilterState({
        group,
        value: group,
        state: '',
      });
    }
  }, [props.group, props.filters]);

  const onChange = value => {
    const { filterDefinition, updateFilterState } = props;
    const { group } = filterDefinition;
    if (props.filterDefinition.max && parseInt(value, 10) > props.filterDefinition.max) {
      return;
    }
    const event = {
      group,
      value: group,
      state: value,
    };
    updateFilterState(event);
  };

  const value = getMyStateFromProps();

  return (
    <div className="list-item">
      <div className="label-selector">
        <InputField type={props.filterDefinition.type} value={value} onChange={e => onChange(e.target.value)} id={props.group} />
        <span>{props.filterDefinition.unit}</span>
      </div>
    </div>
  );
}

Input.propTypes = {
  group: PropTypes.string.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  filters: PropTypes.array.isRequired,
};

export default Input;
